import { Component, forwardRef, Inject, Input, OnInit } from '@angular/core';
import { NgbActiveModal }          from '@ng-bootstrap/ng-bootstrap';
import { TranslateService }       from '@ngx-translate/core';

import { CompanyService }        from '../companies/company.service';
import { CustomerFactoryService } from './customer-factory.service';
import { CodeTypeModel }          from '../core/models/code-type';
import { CustomerModel }          from './models/customer';
import { Table }                  from '../table/types/table';

@Component({
  selector   : 'wor-add-customer-from-branch',
  template: require('./customer.add-from-branch.component.html')
})
export class AddCustomerFromBranchComponent implements OnInit {
  @Input() customerQuickAdd: CustomerModel;

  customers: Array<CustomerModel>;
  selectedCustomer: CustomerModel;

  filters = {
    search_term: '',
    search_type: 'email'
  };

  searchTypes: Array<CodeTypeModel> = [];
  tableSettings: Table;

  constructor(
    public activeModal: NgbActiveModal,
    public companyService: CompanyService,
    @Inject(forwardRef(() => CustomerFactoryService)) private customerFactoryService: CustomerFactoryService,
    private translateService: TranslateService
  ) {}

  ngOnInit (): void {
    this.searchTypes = [
      { code: 'customer_name', description: this.translateService.instant('JS_SPACE.COLUMNS.CUSTOMER_NAME') },
      { code: 'email', description: this.translateService.instant('GENERAL_SPACE.FIELD.EMAIL') },
      { code: 'mobile', description: this.translateService.instant('GENERAL_SPACE.FIELD.MOBILE') }
    ];

    if (this.customerQuickAdd) {
      this.searchTypes.push(
        { code: 'plate_number', description: this.translateService.instant('VEHICLE_SPACE.PLATE_NUMBER', { rego: 'Rego' }) },
        { code: 'vin', description: this.translateService.instant('VEHICLE_SPACE.VIN') }
      );
    }

    this.tableSettings = {
      columns: [
        { field: 'store_name', header: { text: this.translateService.instant('GENERAL_SPACE.FIELD.STORE_NAME') } },
        { classes: 'all-caps', field: 'first_name', header: { text: this.translateService.instant('GENERAL_SPACE.FIELD.FIRST_NAME') } },
        { field: 'last_name', header: { text: this.translateService.instant('GENERAL_SPACE.FIELD.LAST_NAME') } },
        { field: 'email', header: { text: this.translateService.instant('GENERAL_SPACE.FIELD.EMAIL') } }
      ],
      empty: { text: this.translateService.instant('QUERY_DROPDOWN_SPACE.GRID.NO_CUSTOMERS_FOUND') },
      pagination: { enabled: true, pageSize: 5, pageSizes: [5, 10, 25, 50] },
      rows: { highlight: { enabled: true }, select: { enabled: true } },
      sorting: { direction: 'asc', enabled: true, field: 'store_name' },
      static: true
    };
  }

  confirm (): void {
    this.customerFactoryService.copyFromBranch(this.selectedCustomer)
      .then(response => {
        this.activeModal.close(response);
      });
  }

  confirmCustomerSelection(customer: CustomerModel): void {


    this.selectedCustomer = customer;


    this.confirm();


  }

  getCustomers(params?: any): void {
    params = params || { direction: 'asc', field: 'first_name', offset: 0, pageSize: 5 };

    this.customerFactoryService.getBranchCustomers({
      direction  : params.direction || 'asc',
      field      : params.field || 'first_name',
      offset     : params.offset || 0,
      pageSize   : params.pageSize || 5,
      search_term: this.filters.search_term,
      search_type: this.filters.search_type
    }).then((customers: Array<CustomerModel>) => this.customers = customers);
  }

  handleCustomerSelection(customer: CustomerModel): void {


    this.selectedCustomer = customer.selected ? customer : null;


    };


  }
